import { SettingsCategory } from '../enums'
import {
  ACCOUNT_SETTINGS_SUBPAGES,
  DEFAULT_SETTINGS_CATEGORY,
  DEFAULT_SETTINGS_SUBPAGE,
  VALID_SETTINGS_CATEGORIES,
} from '../settings.const'
import type { SettingsNavCategory } from '../settings.interface'

type SettingsPathResult = {
  category: SettingsNavCategory['id']
  subpage: string
}

export function parseSettingsPath(pathname: string): SettingsPathResult {
  const settingsIndex = pathname.indexOf('/settings')
  if (settingsIndex === -1) {
    return { category: DEFAULT_SETTINGS_CATEGORY, subpage: DEFAULT_SETTINGS_SUBPAGE }
  }

  const afterSettings = pathname.slice(settingsIndex + '/settings'.length)
  const segments = afterSettings.split('/').filter(Boolean)

  const rawCategory = segments[0] ?? DEFAULT_SETTINGS_CATEGORY

  if (ACCOUNT_SETTINGS_SUBPAGES.has(rawCategory)) {
    return {
      category: SettingsCategory.ACCOUNT,
      subpage: rawCategory,
    }
  }

  const category = VALID_SETTINGS_CATEGORIES.has(rawCategory as SettingsCategory)
    ? (rawCategory as SettingsCategory)
    : DEFAULT_SETTINGS_CATEGORY

  const subpage = segments[1] ?? DEFAULT_SETTINGS_SUBPAGE

  return { category, subpage }
}
